import React, { Component } from 'react';
import { ComboBox } from '../../../js/ComponentManager'
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
import { Alert, Timmer } from "../../../js/ComponentManager";

/* 개발담당:양유빈
 * 화면기능: 회원가입 양식
 * 세부설명:
*/
export class MemberReg extends Component {
    static displayName = MemberReg.name;
    constructor(props) {
        super(props);
        this.state = {
            MemberModel:{
                Login_Id: "",
                User_Nm: "",
                User_Phone: "",
                Password: "",
                PasswordCheck: "",
                Agreement_Yn: false,
                Privacyagr_Yn: false,
                Optionagr_Yn: false,
                Org_No: "",
                Org_Nm:"",
                Bld_Code: "",
                Flr_Code: "",
                Whole_No_Name: "",
                Org_File_Grp: "",
                Certifi_No: "",
                Reco_Phone: "",
                Reco_Nm:""
            },
            UserNmModel: { "Hide": "item_hide", "Msg": "", "ChkCss": "item_hide", "CheckOk": false },
            PhoneModel: { "Hide": "item_hide", "Msg": "", "ChkCss": "item_hide", "CheckOk": false },
            Reco_PhoneModel: { "Hide": "item_hide", "Msg": "", "ChkCss": "item_hide", "CheckOk": false },
            CertifiModel: { "Hide": "item_hide", "Msg": "", "ChkCss": "item_hide", "CheckOk": false },
            LoginModel: { "Hide": "item_hide", "Msg": "", "ChkCss": "item_hide", "CheckOk": false },
            PassModel: { "Hide": "item_hide", "Msg": "", "ChkCss": "item_hide", "CheckOk": false },
            Pass2Model: { "Hide": "item_hide", "Msg": "", "ChkCss": "item_hide", "CheckOk": false },
            OrgNoModel: { "Hide": "item_hide", "Msg": "", "ChkCss": "item_hide", "CheckOk": false },
            OrgNmModel: { "Hide": "item_hide", "Msg": "", "ChkCss": "item_hide", "CheckOk": false },
            Content: "",
            Title: "",
            Certifi_Css: "item_hide", // 인증번호 입력 가능 보이기
            BldList: [],              // 빌딩콤보 리스트
            FlrList: [],              // 층콤보 리스트
            SeqNo: "",                // 인증번호 발송 Seq
            CertifiNumberOk: false,   //인증성공여부
            isCertifiClick: false,    //인증버튼 재클릭 금지
            RegisterSuccess: false    //회원가입 완료
        };
        //타이머 콤퍼넌트 참조
        this.refTimmer = React.createRef();
        this.handleChange = this.handleChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.handleCertifiSend = this.handleCertifiSend.bind(this);
        this.handleCertifiValid = this.handleCertifiValid.bind(this);
        this.handleClear_Click = this.handleClear_Click.bind(this);
        this.handleWindowLink = this.handleWindowLink.bind(this);
        this.handleBusinessFile = this.handleBusinessFile.bind(this);
        this.handleAlertClick = this.handleAlertClick.bind(this);
        this.handelTermsofservice_Click = this.handelTermsofservice_Click.bind(this);

      
 
    }
    //메세지 처리 속성
    jsonAttr = { "Hide": "item_hide", "Msg": "", "ChkCss": "item_hide","CheckOk":false }
    
    //######입력값 체크 및 자동할당
    handleChange(event) {

        //이름은 한글/영문만 입력 되게 처리
        let tagId = event.target.id;
        let value = event.target.value.trim();
        if (tagId === "User_Phone" || tagId === "Certifi_No" || tagId === "Org_No" || tagId ==="Reco_Phone") {
            //핸드폰,인증번호 숫자만 입력 되게 처리
            let StringText = value.replace(/-/gi, '');
            if (Big3Common.Util.isNumber(StringText) === false) {
                return false;
            }
        }
        else if (tagId === "CheckAll") {
            let checked = event.target.checked;
            Big3Common.updateStateModel({ this: this, modelName: "MemberModel", updateModel: { "Agreement_Yn": checked, "Privacyagr_Yn": checked, "Optionagr_Yn": checked } });
        } else if (tagId === "Bld_Code") {
            let mapList = [];
            this.TempFlrList.map(data => {
                if (data.bld_code === value) {
                    mapList.push(data);
                }
                return false;
            });
            //층코드 초기화
            Big3Common.updateStateModel({ this: this, modelName: "MemberModel", updateModel: { "Flr_Code": ""}});
            this.setState({ FlrList: mapList });
        }
        Big3Common.ValueCahage_StateUpdate({ this: this, event: event, modelName: "MemberModel" });
        return false;
    }
    //검증속성 기본값
    AttrDefaultSet() {
        this.jsonAttr.Hide = "item_hide"; //input_txt,item_hide
        this.jsonAttr.Msg = "";
        this.jsonAttr.CheckOk = false;
        this.jsonAttr.ChkCss = "item_hide"; //false,check,item_hide
    }
    //검증속성 Good
    AttrCheckOkSet() {
        this.jsonAttr.Hide = "input_txt2";
        this.jsonAttr.Msg = "";
        this.jsonAttr.CheckOk = true;
        this.jsonAttr.ChkCss = "check";
    }
    //검증속성 No Good
    AttrErrorSet(Msg) {
        this.jsonAttr.Hide = "input_txt";
        this.jsonAttr.Msg = Msg;
        this.jsonAttr.CheckOk = false;
        this.jsonAttr.ChkCss = "false";
    }
    async handleBlur(event) {
        
        let tagId = event.target.id;
        let ModelName = this.GetModelName(tagId);
        let ModelValue = this.state.MemberModel[tagId];
        let ModelLen = ModelValue.length;
        if (ModelLen === 0) {
            this.AttrDefaultSet();
        }
        if (tagId === "User_Nm" && ModelLen >0) {
            this.AttrCheckOkSet();
        }
        else if (tagId === "User_Phone" && ModelLen > 0) {
            let isCheck = Big3Common.Util.HandPhoneCheck(ModelValue);
            if (!isCheck) {
                this.AttrErrorSet("핸드폰번호 형식이 잘못 되었습니다.");
            }
            else {
                let hpFormat = Big3Common.Util.HandPhoneFormat(ModelValue);
                let Data = await Big3Common.Post("api/Common/Common/PhoneNumberValid", { "user_phone": hpFormat });
                if (Data.codeName === Big3Common.ResultCode.Success) {
                    //인증성공
                    Big3Common.updateStateModel({ this: this, modelName: "MemberModel", updateModel: { [tagId]: hpFormat } });
                    //핸드폰 중복체크 하고 성공이면 아래 로직
                    this.AttrCheckOkSet();
                    this.jsonAttr.Hide = "input_txt2";
                    this.jsonAttr.Msg = "인증번호 전송 버튼을 클릭하세요.";
                }
                else {
                    //오류
                    this.AttrErrorSet(Data.message);
                }
                
            }
        }
        else if (tagId === "Reco_Phone" && ModelLen > 0) {
            let isCheck = Big3Common.Util.HandPhoneCheck(ModelValue);
            if (!isCheck) {
                this.AttrErrorSet("핸드폰번호 형식이 잘못 되었습니다.");
            }
            else {
                let hpFormat = Big3Common.Util.HandPhoneFormat(ModelValue);
                Big3Common.updateStateModel({ this: this, modelName: "MemberModel", updateModel: { [tagId]: hpFormat } });
                this.AttrCheckOkSet();
            }
        }
        else if (tagId === "Login_Id" && ModelLen > 0) {
            let isCheck = Big3Common.Util.isUserIdValid(ModelValue);
            if (!isCheck) {
                this.AttrErrorSet("영문,숫자 조합 6~20자리를 입력해주세요.");
            }
            else {
                //아이디 서버에서 중복검사
                try {
                    let Data = await Big3Common.Post("api/Common/Common/LoginIdValid", { "login_id": this.state.MemberModel.Login_Id });
                    if (Data.codeName === Big3Common.ResultCode.Success) {
                        //인증성공
                        this.AttrCheckOkSet();
                        this.jsonAttr.Msg = Data.message;
                    }
                    else {
                        this.AttrErrorSet(Data.message);
                    } 
                }
                catch (e) {
                    console.log("handleBlur:", e);
                }
            }
        }
        else if (tagId === "Password" && ModelLen > 0) {
            let isCheck = Big3Common.Util.isPassWordValid(ModelValue);
            if (!isCheck) {
                this.AttrErrorSet("영문 대, 소문자, 특수기호를 포함 8~20자리를 입력해주세요.");
            }
            else {
                this.AttrCheckOkSet();
            }
        }
        else if (tagId === "PasswordCheck" && ModelLen > 0) {
            if (this.state.MemberModel.Password !== this.state.MemberModel.PasswordCheck) {
                this.AttrErrorSet("비밀번호가 일치하지 않습니다.");
            }
            else {
                this.AttrCheckOkSet();
            }
        }
        else if (tagId === "Org_No" && ModelLen > 0) {
            let isCheck = Big3Common.Util.OrgNumberCheck(ModelValue);
            if (!isCheck) {
                this.AttrErrorSet("사업자번호 형식이 잘못 되었습니다.");
            }
            else {
                const orgFormat = Big3Common.Util.OrgNumberFormat(ModelValue);
                Big3Common.updateStateModel({ this: this, modelName: "MemberModel", updateModel: { [tagId]: orgFormat } });
                this.AttrCheckOkSet();
            }
        }
        else if (tagId === "Org_Nm" && ModelLen > 0) {
            this.AttrCheckOkSet();
        }

        if (ModelName === "") return false;

        Big3Common.updateStateModel({ this: this, modelName: ModelName, updateModel: this.jsonAttr });
        event.preventDefault();
    }
    //X 버튼 클릭시 값 초기화
    handleClear_Click(tagId) {
        let ModelName = this.GetModelName(tagId);
        this.AttrDefaultSet();
        Big3Common.updateStateModel({ this: this, modelName: "MemberModel", updateModel: { [tagId]: "" } });
        this.AttrDefaultSet();
        Big3Common.updateStateModel({ this: this, modelName: ModelName, updateModel: this.jsonAttr });
        return false;
    }
    //인증번호 전송
    async handleCertifiSend(event) {

        if (!this.state.PhoneModel.CheckOk) {
            this.AttrErrorSet("핸드폰 번호를 확인하여 주세요.");
            Big3Common.updateStateModel({ this: this, modelName: "PhoneModel", updateModel: this.jsonAttr });
        }
        else {
            if (this.state.isCertifiClick) {
                return false;
            }
            this.setState({ "isCertifiClick": true });
            
            try {
                const hpFormat = Big3Common.Util.HandPhoneFormat(this.state.MemberModel.User_Phone);
                let Data = await Big3Common.Post("api/Common/Common/Certifino", { "user_phone": hpFormat });
                if (Data.codeName === Big3Common.ResultCode.Success) {
                    let seqno = Data.objectData;
                    this.setState({ "SeqNo": seqno });
                    this.AttrCheckOkSet();
                    this.jsonAttr.Msg = Data.message;
                    Big3Common.updateStateModel({ this: this, modelName: "PhoneModel", updateModel: this.jsonAttr });

                    //재전송 클릭 시 입력시간 초과 메세지 클리어
                    this.AttrDefaultSet();
                    Big3Common.updateStateModel({ this: this, modelName: "CertifiModel", updateModel: this.jsonAttr });

                    //인증번호 전송 후 타이머 쇼
                    this.setState({ Certifi_Css: "input_line" });
                    this.refTimmer.current.Play();
                }
                else {
                    this.AttrErrorSet();
                    this.jsonAttr.Msg = Data.message;
                    Big3Common.updateStateModel({ this: this, modelName: "PhoneModel", updateModel: this.jsonAttr });
                }
            }
            catch (e) {
                console.log("handleCertifiSend: ", e);
            }          
        }      
        
        event.preventDefault();
    }
    //인증번호 확인
    async handleCertifiValid(event) {
        if (this.state.CertifiNumberOk === true) {
            //이미 인증했음.
            return false;
        }
        if (this.refTimmer.current.isTimeOut()) {
            this.AttrErrorSet("입력시간이 초과 되었습니다.");
            this.setState({ "SeqNo": "", "isCertifiClick": false });
        }
        else if (this.state.MemberModel.Certifi_No.trim().length === 0)
        {
            this.AttrErrorSet("인증번호를 입력하여 주세요.");
        }
        else {

            try {
                let Data = await Big3Common.Post("api/Common/Common/CertifinoVerification", { "seqno": this.state.SeqNo, "certifi_no": this.state.MemberModel.Certifi_No });
                if (Data.codeName === Big3Common.ResultCode.Success) {
                    //인증성공
                    this.setState({ "CertifiNumberOk": true });
                    this.refTimmer.current.Stop();
                    this.AttrCheckOkSet();
                    this.jsonAttr.Msg = Data.message;
                }
                else if (Data.codeName === Big3Common.ResultCode.Warning) {
                    //인증번호 불일치
                    this.AttrErrorSet(Data.message);
                }
                else {
                    //오류
                    this.AttrErrorSet(Data.message);
                    this.setState({ "SeqNo": "", "isCertifiClick": false });
                }
            }
            catch (e) {
                console.log("handleCertifiValid :", e);
            }
        }
        Big3Common.updateStateModel({ this: this, modelName: "CertifiModel", updateModel: this.jsonAttr });
        event.preventDefault();
    }

    async handleSave(event) {

        if (this.state.MemberModel.User_Nm.trim().length === 0) {
            this.setState({ Title: "대표자명을 입력하세요." });
        }
        else if (this.state.MemberModel.User_Phone.trim().length === 0) {
            this.setState({ Title: "휴대폰번호를 입력하세요." });
        }
        else if (!this.state.PhoneModel.CheckOk)
        {
            this.setState({ Title: "휴대폰번호 형식을 확인하여 주세요." });
        }
        else if (this.state.MemberModel.Certifi_No.trim().length === 0) {
            this.setState({ Title: "인증번호를 입력하여 주세요." });
        }
        else if (!this.state.CertifiModel.CheckOk){
            this.setState({ Title: "인증번호가 일치하지 않습니다." });
        }
        else if (this.state.MemberModel.Login_Id.trim().length === 0) {
            this.setState({ Title: "아이디를 입력하여 주세요." });
        }
        else if (!this.state.LoginModel.CheckOk)
        {
            this.setState({ Title: "아이디를 확인하여 주세요." });
        }
        else if (this.state.MemberModel.Password.trim().length === 0) {
            this.setState({ Title: "비밀번호를 입력하여 주세요." });
        }
        else if (this.state.MemberModel.PasswordCheck.trim().length === 0) {
            this.setState({ Title: "비밀번호를 확인을 입력하여 주세요." });
        }
        else if (this.state.MemberModel.Password.trim() !== this.state.MemberModel.PasswordCheck.trim()){
            this.setState({ Title: "비밀번호가 일치하지 않습니다." });
        }
        else if (!this.state.PassModel.CheckOk)
        {
            this.setState({ Title: "비밀번호는 영문 대, 소문자, 특수기호를 포함 8~20자리를 입력해주세요." });
        }
        else if (this.state.MemberModel.Org_No.trim().length === 0) {
            this.setState({ Title: "사업자등록번호를 입력하여 주세요." });
        }
        else if (this.state.MemberModel.Org_File_Grp.trim().length === 0){
            this.setState({ Title: "사업자등록증을 첨부하여 주세요." });
        }
        else if (this.state.MemberModel.Org_Nm.trim().length === 0) {
            this.setState({ Title: "상호명을 입력하여 주세요." });
        }
        else if (this.state.MemberModel.Bld_Code.trim().length === 0) {
            this.setState({ Title: "건물을 선택하여 주세요." });
        }
        else if (this.state.MemberModel.Flr_Code.trim().length === 0) {
            this.setState({ Title: "층수를 선택하여 주세요." });
        }
        else if (this.state.MemberModel.Whole_No_Name.trim().length === 0) {
            this.setState({ Title: "호수를 입력하여 주세요." });
        }
        else if (!this.state.MemberModel.Agreement_Yn) {
            this.setState({ Title: "서비스 이용약관을 동의하여 주세요." });
        }
        else if (!this.state.MemberModel.Privacyagr_Yn) {
            this.setState({ Title: "개인정보처리방침에 동의하여 주세요." });
        }
        else if (!this.state.CertifiNumberOk) {
            this.setState({ Title: "인증번호 인증이 완료되지 않았습니다." });
        }
        else if (this.state.MemberModel.Reco_Nm.trim().length === 0 && this.state.MemberModel.Reco_Phone.trim().length > 0)
        {
            this.setState({ Title: "추천인 이름을 입력하여 주세요." });
        }
        else if (this.state.MemberModel.Reco_Nm.trim().length > 0 && this.state.MemberModel.Reco_Phone.trim().length===0) {
            this.setState({ Title: "추천인 연락처를 입력하여 주세요." });
        }
        else {
            //회원정보 저장
            try {
                let MemberModel = this.state.MemberModel;
                MemberModel.SeqNo = this.state.SeqNo;

                const hpFormat = Big3Common.Util.HandPhoneFormat(this.state.MemberModel.User_Phone);
                MemberModel.User_Phone = hpFormat;

                const orgFormat = Big3Common.Util.OrgNumberFormat(this.state.MemberModel.Org_No);
                MemberModel.Org_No = orgFormat;

                if (this.state.MemberModel.Reco_Phone.trim().length > 0) {
                    const Reco_Phone_Format = Big3Common.Util.OrgNumberFormat(this.state.MemberModel.Reco_Phone);
                    MemberModel.Reco_Phone = Reco_Phone_Format;
                }

                let Data = await Big3Common.Post("api/Account/MemberMgr/MemberSave", MemberModel, true);
                if (Data.codeName === Big3Common.ResultCode.Success) {
                    this.setState({ Title: "회원가입 요청이 완료되었습니다.", Content: "승인까지 영업일 기준 2~3정도 소요됩니다.", RegisterSuccess: true });
                    //Google Ads
                    Big3Common.AdsPlugin.MEMBER_END_EVENT();
                }
                else {
                    this.setState({ Title: "회원가입 오류", Content: Data.message });
                }
            }
            catch (e) {
                console.log("handleSave :", e);
            }
        }

        Big3Common.ModalAlert(bootstrap, 'MessageAlert');
    }
    handleAlertClick(modalId) {
        if (this.state.RegisterSuccess) {
            window.location.href = "/Account/LoginMgr/Index";
        }
    }
    //사업자 등록증 업로드
    handleBusinessFile(event) {
        
        let StateCopy=Big3Common.WebStorage.StateStorage(this.state, ["Content", "Title", "BldList", "FlrList"]);
        this.props.RenderComponent('BusinessInfo', StateCopy);
        event.preventDefault();
    }
    //서비스이용약관
    handelTermsofservice_Click(ComponentName) {
        let StateCopy = Big3Common.WebStorage.StateStorage(this.state, ["Content", "Title", "BldList", "FlrList"]);
        this.props.RenderComponent(ComponentName, StateCopy);
    }
    GetModelName(tagId) {
        if (tagId === "User_Nm") {
            return "UserNmModel";
        }
        else if (tagId === "User_Phone") {
            return "PhoneModel";
        }
        else if (tagId === "Certifi_No") {
            return "CertifiModel";
        }
        else if (tagId === "Login_Id") {
            return "LoginModel";
        }
        else if (tagId === "Password") {
            return "PassModel";
        }
        else if (tagId === "PasswordCheck")
        {
            return "Pass2Model";
        }
        else if (tagId === "Org_No")
        {
            return "OrgNoModel";
        }
        else if (tagId === "Org_Nm")
        {
            return "OrgNmModel";
        }
        else if (tagId === "Reco_Phone") {
            return "Reco_PhoneModel";
        }
        else {
            return "";
        }
        
    }
    handleWindowLink(url) {

    }
    //초기화 파일 업로드 화면 이동 후 값이 있으면 다시 설정
    componentDidMount() {
        //Google Ads
        Big3Common.AdsPlugin.MEMBER_LOAD_EVENT();
        this.DefaultData();
    }
    TempFlrList = [];
    async DefaultData() {
        try {
            let Data = await Big3Common.Get("api/Common/Common/BldMgt");
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let DataSet = JSON.parse(Data.multiDataTable);
                let BldList = DataSet.BldList;
                this.TempFlrList = DataSet.FlrList;
                this.setState({ BldList: BldList });

                //첨부파일 등록 후 이전 등록된 값 셋팅
                if (this.props.ContentState !== null) {
                    let StateList = this.props.ContentState;
                    await Object.keys(StateList).map(key => {
                        let objValue = StateList[key];
                        if (key === "MemberModel") {
                            //첨부파일 등록 화면에서 세션스토리지에 등록번호를 읽어 할당.
                            let FileGrpKey = Big3Common.WebStorage.GetSessionStorage(Big3Common.WebStorage.StorageName.FileGrpKey);
                            objValue.Org_File_Grp = FileGrpKey == null ? "" : FileGrpKey;
                        }
                        if (key.includes("Model")) {
                            Big3Common.updateStateModel({ this: this, modelName: key, updateModel: objValue });
                        }
                        else {
                            this.setState({ [key]: objValue });
                        }
                        return false;
                    });

                }
            }
            
        }
        catch (e) {
            console.log("DefaultData :", e);
        }
    }
    render() {
        return (

            <form>
                <div className="join_box container-md">
                    <div className="input_line">
                        <label>대표자명</label>
                        <input type="text"
                            id="User_Nm"
                            className="form-control"
                            maxLength="10"
                            placeholder="실명을 입력하세요"
                            value={this.state.MemberModel.User_Nm}
                            onChange={this.handleChange}
                            onBlur={this.handleBlur}
                        />
                        <div className={this.state.UserNmModel.ChkCss} ></div>
                    </div>
                    <div className="input_line">
                        <label>휴대폰번호</label>
                        <div className="nc_box">
                            <input type="tel"
                                id="User_Phone"
                                className="form-control cn_input"
                                maxLength="13"
                                pattern="\d*"
                                placeholder="휴대폰번호를 입력하세요.(-는 제외)"
                                value={this.state.MemberModel.User_Phone}
                                onChange={this.handleChange}
                                onBlur={this.handleBlur}
                            />
                            <button type="button" className={this.state.SeqNo === "" ? "cn_button btn_v1" : "cn_button btn_inactive"} onClick={this.handleCertifiSend} >인증번호 전송</button>
                        </div>
                        <div className={this.state.PhoneModel.Hide}>{this.state.PhoneModel.Msg}</div>
                        <div className={this.state.PhoneModel.ChkCss} style={{ marginRight: 100 }} onClick={() => this.handleClear_Click('User_Phone')}  ></div>
                    </div>
                    <div className={this.state.Certifi_Css} >
                        <label>인증번호</label>
                        <div className="nc_box">
                            <input type="text"
                                id="Certifi_No"
                                className="form-control cn_input"
                                maxLength="6"
                                value={this.state.MemberModel.Certifi_No}
                                onChange={this.handleChange}
                            />
                            <div className="time_1">
                                <Timmer Minutes="5"
                                    Seconds="0"
                                    ref={this.refTimmer}
                                />
                            </div>
                            <button type="button" className={this.state.CertifiNumberOk === true ? "cn_button btn_inactive" : "cn_button btn_v1"} onClick={this.handleCertifiValid}>인증 확인</button>
                        </div>
                        <div className={this.state.CertifiModel.Hide}>{this.state.CertifiModel.Msg}</div>
                        <div className={this.state.CertifiModel.ChkCss} style={{ marginRight: 170 }} onClick={() => this.handleClear_Click('Certifi_No')}  ></div>
                    </div>
                    <div className="input_line">
                        <label>아이디</label>
                        <input type="text"
                            id="Login_Id"
                            className="form-control"
                            maxLength="20"
                            placeholder="문자/숫자 조합 최소 8자리를 입력해주세요."
                            value={this.state.MemberModel.Login_Id}
                            onChange={this.handleChange}
                            onBlur={this.handleBlur}
                        />
                        <div className={this.state.LoginModel.Hide}>{this.state.LoginModel.Msg}</div>
                        <div className={this.state.LoginModel.ChkCss} onClick={() => this.handleClear_Click('Login_Id')}></div>
                    </div>
                    <div className="input_line">
                        <label>비밀번호</label>
                        <input type="password"
                            id="Password"
                            className="form-control"
                            maxLength="20"
                            autoComplete="off"
                            placeholder="비밀번호를 등록하여 주세요."
                            value={this.state.MemberModel.Password}
                            onChange={this.handleChange}
                            onBlur={this.handleBlur}
                        />
                        <div className={this.state.PassModel.Hide}>{this.state.PassModel.Msg}</div>
                        <div className={this.state.PassModel.ChkCss} onClick={() => this.handleClear_Click('Password')}></div>
                    </div>
                    <div className="input_line">
                        <label>비밀번호 확인</label>
                        <input type="password"
                            id="PasswordCheck"
                            className="form-control"
                            maxLength="20"
                            autoComplete="off"
                            placeholder="비밀번호를 확인을 등록하여 주세요."
                            value={this.state.MemberModel.PasswordCheck}
                            onChange={this.handleChange}
                            onBlur={this.handleBlur}
                        />
                        <div className={this.state.Pass2Model.Hide}>{this.state.Pass2Model.Msg}</div>
                        <div className={this.state.Pass2Model.ChkCss} onClick={() => this.handleClear_Click('PasswordCheck')}></div>
                    </div>
                    <div className="input_line">
                        <label>사업자등록번호</label>
                        <div className="nc_box">
                            <input type="tel"
                                id="Org_No"
                                className="form-control cn_input"
                                maxLength="12"
                                placeholder="사업자등록번호 입력(- 는 제외)"
                                value={this.state.MemberModel.Org_No}
                                onChange={this.handleChange}
                                onBlur={this.handleBlur}
                            />
                            <button type="button" className="cn_button btn_v1" onClick={this.handleBusinessFile} >사업자등록증<br />첨부</button>
                        </div>
                        <div className={this.state.OrgNoModel.Hide}>{this.state.OrgNoModel.Msg}</div>
                        <div className={this.state.OrgNoModel.ChkCss} onClick={() => this.handleClear_Click('Org_No')} style={{ marginRight: 100 }} ></div>
                    </div>
                    <div className="input_line">
                        <label>상호명</label>
                        <input type="text"
                            id="Org_Nm"
                            className="form-control"
                            maxLength="50"
                            placeholder="상호명을 입력하세요."
                            value={this.state.MemberModel.Org_Nm}
                            onChange={this.handleChange}
                            onBlur={this.handleBlur}
                        />
                        <div className={this.state.OrgNmModel.Hide}>{this.state.OrgNmModel.Msg}</div>
                        <div className={this.state.OrgNmModel.ChkCss} onClick={() => this.handleClear_Click('Org_Nm')}></div>
                    </div>
                    <div className="input_line">
                        <label>매장위치</label>
                        <div className="select_box">
                            <ComboBox id="Bld_Code"
                                ComboChange={this.handleChange}
                                emptyText="건물"
                                textName="bld_name"
                                valueName="bld_code"
                                setValue={this.state.Bld_Code}
                                optionList={this.state.BldList}
                            />
                            <ComboBox id="Flr_Code"
                                ComboChange={this.handleChange}
                                emptyText="층수"
                                textName="flr_name"
                                valueName="flr_code"
                                optionList={this.state.FlrList}
                                setValue={this.state.Flr_Code}
                                
                            />
                            <input type="text"
                                className="form-control"
                                id="Whole_No_Name"
                                maxLength="10"
                                placeholder="호수(직접입력)"
                                onChange={this.handleChange}
                                value={this.state.MemberModel.Whole_No_Name}
                            />
                        </div>
                        <div className="input_txt"></div>
                    </div>
                    <div className="input_line">
                        <label>추천인</label>
                        <div className="recommender">
                            <input type="text"
                                className="form-control_v2"
                                id="Reco_Nm"
                                maxLength="10"
                                placeholder="이름을 입력하세요."
                                onChange={this.handleChange}
                                value={this.state.MemberModel.Reco_Nm}
                            />
                            <input type="text"
                                className="form-control_v2"
                                id="Reco_Phone"
                                maxLength="13"
                                placeholder="휴대폰번호를 입력하세요.(-는 제외)"
                                onChange={this.handleChange}
                                onBlur={this.handleBlur}
                                value={this.state.MemberModel.Reco_Phone}
                            />
                        </div>
                        <div className={this.state.Reco_PhoneModel.Hide}>{this.state.Reco_PhoneModel.Msg}</div>
                    </div>
                    <div className="agree_box">
                        <p>필수 가입정보를 입력해 주시고 서비스 정책에<br className="mobile_br" /> 동의해주세요.</p>
                        <div className="agree_line">
                            <div className="agree_line_in">
                                <input className="form-check-input" id="CheckAll" type="checkbox" onChange={this.handleChange} />
                                <label className="form-check-label">
                                    약관에 모두 동의합니다.
                                </label>
                            </div>
                        </div>
                        <div className="line"></div>
                        <div className="agree_line">
                            <div className="agree_line_in">
                                <input className="form-check-input"
                                    type="checkbox"
                                    id="Agreement_Yn"
                                    onChange={this.handleChange}
                                    checked={this.state.MemberModel.Agreement_Yn}
                                />
                                <label className="form-check-label">
                                    [필수] 서비스 이용약관에 동의합니다.
                                </label>
                            </div>
                            <a href="#!" className="go_page" onClick={(e) => { this.handelTermsofservice_Click('Termsofservice'); e.preventDefault(); } } > </a>
                        </div>
                        <div className="agree_line">
                            <div className="agree_line_in">
                                <input className="form-check-input"
                                    type="checkbox"
                                    id="Privacyagr_Yn"
                                    onChange={this.handleChange}
                                    checked={this.state.MemberModel.Privacyagr_Yn}
                                />
                                <label className="form-check-label">
                                    [필수] 개인정보처리방침에 동의합니다.
                                </label>
                            </div>
                            <a href="#!" className="go_page" onClick={(e) => { this.handelTermsofservice_Click('Privacypolicy'); e.preventDefault(); }} > </a>
                        </div>
                        <div className="agree_line">
                            <div className="agree_line_in">
                                <input className="form-check-input"
                                    type="checkbox"
                                    id="Optionagr_Yn"
                                    onChange={this.handleChange}
                                    checked={this.state.MemberModel.Optionagr_Yn}
                                />
                                <label className="form-check-label">
                                    [선택] 마케팅수신약관에 동의합니다.
                                </label>
                            </div>
                            <a href="#!" className="go_page" onClick={(e) => { this.handelTermsofservice_Click('Privacypolicy'); e.preventDefault(); }} > </a>
                        </div>
                    </div>
                    <div className="join_btn_line">
                        <button type="button" className="btn_v btn_v1" onClick={this.handleSave} >가입하기</button>
                    </div>
                </div>
                <Alert
                    id="MessageAlert"
                    content={this.state.Content}
                    title={this.state.Title}
                    AlertClick={this.handleAlertClick} 
                />
            </form>
        );
        
    }
}
